var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"}));
}

ArrowLeft.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
